import { createContext } from 'react';

import { DataModelAttribute } from '@/types/DataModel';

interface FocusAttributeContextType {
  focusAttribute: DataModelAttribute | undefined;
  setFocusAttribute: React.Dispatch<React.SetStateAction<DataModelAttribute | undefined>>;
  sectionOpen: boolean;
  setSectionOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FocusAttributeContext = createContext<FocusAttributeContextType | undefined>(undefined);

